import { IQuestionModel } from '@care-portals/api-interfaces';

const caProvinces = [
  { code: 'AB', province: 'Alberta' },
  { code: 'BC', province: 'British Columbia' },
  { code: 'MB', province: 'Manitoba' },
  { code: 'NB', province: 'New Brunswick' },
  { code: 'NL', province: 'Newfoundland and Labrador' },
  { code: 'NS', province: 'Nova Scotia' },
  { code: 'ON', province: 'Ontario' },
  { code: 'PE', province: 'Prince Edward Island' },
  { code: 'QC', province: 'Quebec' },
  { code: 'SK', province: 'Saskatchewan' }
];

const questionsModels: IQuestionModel[] = [
  {
    label: 'Since starting treatment, how has your weight changed?',
    field: 'wlMonthlyWeightChange',
    type: 'select',
    required: true,
    answer: {
      type: 'single_select',
      options: [
        { key: 'decreasedMoreThanExpected', value: '⬇️ Decreased more than expected' },
        { key: 'decreasedALittle', value: '⬇️ Decreased a little' },
        { key: 'aboutTheSame', value: '➖ About the same' },
        { key: 'increased', value: '⬆️ Increased' },
        { key: 'notTracking', value: "I'm not tracking my weight" }
      ]
    }
  },
  {
    label: "That's okay — we've got a simple way to track progress.",
    subLabel: "Going forward, you'll receive a short weekly weigh-in and photo check-in. This helps you track changes over time and gives your care team a clearer picture of how your body is responding.",
    field: 'wlMonthlyWeightTrackingInfo',
    type: 'info',
    answer: {}
  },
  {
    label: 'How do you feel about your progress so far?',
    field: 'wlMonthlyProgressConfidence',
    type: 'select',
    required: true,
    answer: {
      type: 'single_select',
      options: [
        { key: 'confident', value: 'Confident — this feels on track' },
        { key: 'unsure', value: "Unsure — not sure what's normal yet" },
        { key: 'concerned', value: "Concerned — I expected more by now" },
        { key: 'frustrated', value: 'Frustrated — I feel stuck' }
      ]
    }
  },
  {
    label: 'Have you experienced any side effects?',
    field: 'wlMonthlySideEffects',
    type: 'select',
    required: true,
    answer: {
      type: 'single_select',
      options: [
        { key: 'none', value: 'None' },
        { key: 'mildManageable', value: 'Mild and manageable' },
        { key: 'moderate', value: 'Moderate — affecting daily life' },
        { key: 'severeWorsening', value: 'Severe or worsening' }
      ]
    }
  },
  {
    label: 'How consistently have you taken your medication?',
    field: 'wlMonthlyAdherence',
    type: 'select',
    required: true,
    answer: {
      type: 'single_select',
      options: [
        { key: 'exactlyAsPrescribed', value: 'Exactly as prescribed' },
        { key: 'missedDoseOrTwo', value: 'Missed a dose or two' },
        { key: 'frequentlyMissed', value: 'Frequently missed doses' },
        { key: 'stoppedForPeriod', value: 'I stopped for a period' }
      ]
    }
  },
  {
    label: 'Compared to before treatment, how does appetite or food control feel now?',
    field: 'wlMonthlyAppetiteControl',
    type: 'select',
    required: true,
    answer: {
      type: 'single_select',
      options: [
        { key: 'muchEasier', value: 'Much easier to manage' },
        { key: 'slightlyEasier', value: 'Slightly easier' },
        { key: 'noChange', value: 'No real change' },
        { key: 'harder', value: 'Harder than before' }
      ]
    }
  },
  {
    label: 'What would help most right now?',
    field: 'wlMonthlyIntentSignal',
    type: 'select',
    required: true,
    answer: {
      type: 'single_select',
      options: [
        { key: 'knowingNormal', value: 'Just knowing this is normal' },
        { key: 'understandingExpectations', value: 'Understanding what to expect next' },
        { key: 'adjustingSomething', value: 'Adjusting something if needed' },
        { key: 'thinkingAboutStopping', value: "I'm thinking about stopping" }
      ]
    }
  },
  {
    label: 'Which province do you currently live in?',
    field: 'wlMonthlyProvince',
    type: 'info',
    required: true,
    answer: {
      type: 'dropdown',
      name: 'province',
      placeholder: 'Please select',
      options: caProvinces.map(item => ({
        key: item.code,
        value: item.province
      }))
    }
  }
];

export default questionsModels;

